import React from "react";
import SideMenuTopBarLayout from "common/layouts/SideMenuTopBarLayout/SideMenuTopBarLayout";
import { Navigate } from "react-router-dom";
import ProveedorProtectedRoute from "./ProveedorProctedRoute";
import RegistroDocumentoView from "modules/proveedor/components/views/RegistroDocumentoView/RegistroDocumentoView";
import NuevoTramiteView from "modules/proveedor/components/views/NuevoTramiteView/NuevoTramiteView";
import EnProcesoView from "modules/proveedor/components/views/EnProcesoView/EnProcesoView";
import DetalleTramiteView from "modules/proveedor/components/views/DetalleTramiteView/DetalleTramiteView";
import DashboardView from "modules/proveedor/components/views/DashboardView/DashboardView";
import YaPagadosView from "modules/proveedor/components/views/YaPagadosView/YaPagadosView";
const SpecializedSearchPage = React.lazy(() => import("modules/general/components/views/SpecializedSearchPage/SpecializedSearchPage"));


/* 
    NOTA:
    En Element debe ir el Layout y el Layout debe tener como props.children la el view que
    se va usar? 
*/


const ProveedorRoutes = [
    {
      path: "/dashboard",
      index:true,
      element: (
        <ProveedorProtectedRoute>
          <SideMenuTopBarLayout classes={['dashboard-page']}> 
              <DashboardView />
          </SideMenuTopBarLayout>
        </ProveedorProtectedRoute>
      ),
    },
    {
      path: "/registro-documento",
      element:<ProveedorProtectedRoute>
        <SideMenuTopBarLayout classes={['registro-doc-page']}> 
          <RegistroDocumentoView   />
        </SideMenuTopBarLayout>
      </ProveedorProtectedRoute>,
    },
    {
      path: '/registro-documento/:tipo',
      element: <ProveedorProtectedRoute><SideMenuTopBarLayout classes={['registro-doc-page','fisico']}> 
          <NuevoTramiteView />
      </SideMenuTopBarLayout></ProveedorProtectedRoute>,
    }/*,
    {
      path: '/en-proceso',
      element:  <ProveedorProtectedRoute><SideMenuTopBarLayout  classes={['registro-doc-page','detalle']}> 
            <EnProcesoView />
      </SideMenuTopBarLayout></ProveedorProtectedRoute>,
    }*/
    ,
    {
        path: '/proveedor/tramites/search',
        element: 
        <ProveedorProtectedRoute><SideMenuTopBarLayout  classes={['registro-doc-page','fisico']}>
            <SpecializedSearchPage profile="proveedor-search" />
          </SideMenuTopBarLayout></ProveedorProtectedRoute>
        
      },
    {
      path: '/ya-pagados',
      element:  <ProveedorProtectedRoute><SideMenuTopBarLayout  classes={['registro-doc-page','detalle']}> 
            <YaPagadosView />
      </SideMenuTopBarLayout></ProveedorProtectedRoute>,
    },
    {
      path: '/detalle-tramite/:dossierID',
      element:  <ProveedorProtectedRoute><SideMenuTopBarLayout  classes={['registro-doc-page','detalle']}> 
            <DetalleTramiteView />
      </SideMenuTopBarLayout></ProveedorProtectedRoute>,
    }
];

export default ProveedorRoutes;